import { h, Component } from 'preact'
import style from './styles/checkbox.scss'

import Icon from '../Icon'
import Button from './Button'
import HScroll from '../HScroll'

class Checkbox extends Component {
  constructor(props) {
    super(props)
    this.state = {
      answers: props.answers.map(a => ({
        ...a,
        isChecked: false
      })),
      checkedCount: 0
    }
  }

  showCheckbox(answers) {
    return answers.map((a, i) => (
      <button class={a.isChecked ? style.active : style.button} data-index={i} onClick={this.handleCheck}>{a.title}</button>
    ))
  }

  updateState = (index) => {
    return (prev) => {
      const answers = prev.answers.concat()
      const checkedCount = prev.answers[index].isChecked ?
      (prev.checkedCount - 1)
      : (prev.checkedCount + 1)

      answers[index] = {
        ...prev.answers[index],
        isChecked: !prev.answers[index].isChecked
      }


      return {answers, checkedCount}
    }
  }

  handleCheck = (event) => {
    event.preventDefault()

    const index = event.target.getAttribute('data-index')
    this.setState(this.updateState(index))
  }

  handleContinue = () => {
    const {onChecked} = this.props
    const {answers} = this.state

    const ids = answers.filter(a => a.isChecked).map(a => a.id)

    if (typeof onChecked === 'function') {
      onChecked(ids)
    }
  }

  render(props, {answers, checkedCount}) {
    return (
      <div class={style.normal}>
        <HScroll>
          {this.showCheckbox(answers)}
        </HScroll>
        <Button disabled={checkedCount === 0} class={style.single} onClick={this.handleContinue}>Далее <Icon class={style.icon} icon="arrow-right" /></Button>
      </div>
    )
  }
}

export default Checkbox



// WEBPACK FOOTER //
// ./components/forms/Checkbox.js